import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { GameServices } from '../../services/game-services';
import { DragData, ShapeViewModel } from './shape-view-model';
import { Subject } from 'rxjs';
import { Shape } from 'src/games/phaserblocks/logic/models/shape';

export class ShapeBoardViewModel {
  public get blocksLogicActionBus$() {
    return this.gameServices.gameRunnerService.blocksLogicActionBus$;
  }
  public get onGameSetupStartTrigger() {
    return this.gameServices.gameRunnerService.onGameSetupStartTrigger;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get allShapeViewModels() {
    return this.shapeViewModels;
  }
  public get onShapeDragAction$() {
    return this.shapeDragAction.asObservable();
  }

  private shapeViewModels: ShapeViewModel[] = [];

  private readonly onResetGameScene = new Subject<void>();
  private readonly shapeDragAction = new Subject<DragData>();

  constructor(private gameServices: GameServices) {}

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public spawnShapes(): boolean {
    const game = this.gameServices.gameRunnerService.currentGame;
    if (game === undefined) {
      return false;
    }

    this.shapeViewModels = game.currentShapes.map((shape, index) => {
      const shapeViewModel = new ShapeViewModel(this.gameServices, shape, index);
      shapeViewModel.onDragAction = (dragData: DragData) => {
        this.shapeDragAction.next(dragData);
      };
      return shapeViewModel;
    });
    return true;
  }

  public refreshRemainingShapes(validShapes: Shape[]): void {
    this.shapeViewModels.forEach((shapeViewModel) => {
      shapeViewModel.setValid(
        validShapes.some((shape) => shape.id === shapeViewModel.currentShape.id),
      );
    });
  }

  public destroyShape(shapeId: string) {
    removeShapeById(this.shapeViewModels, shapeId);
  }

  public resetGameScene() {
    this.onResetGameScene.next();
    this.shapeViewModels.length = 0;
  }
}

function removeShapeById(list: ShapeViewModel[], shapeId: string): void {
  const index = list.findIndex((item) => item.currentShape.id === shapeId);
  if (index !== -1) {
    list.splice(index, 1);
  }
}
